import { BaseWebComponentController, IListenerConfig } from '../../../../framework/BaseWebComponentController';
import { templateEasmScanConfigurationScheduler } from '../view/template';
import { EasmScanConfigurationSchedulerView } from '../view/EasmScanConfigurationSchedulerView';
import { EasmScanConfigurationSchedulerWebComponent } from '../component/EasmScanConfigurationSchedulerWebComponent';
import { EasmScanConfigurationSchedulerSchema, EASMSchedulerEvents } from '../types';
import { ConsoleRequest, DataProviderType } from '../../../../utils/request';
import { MultiSelectEvents } from '../../../../ui/gzMultiSelect/types';
import { WeekDays } from '../../../../network/reconfigureAgent/common/reconfigureAgentShedulerForm/types';

export class EasmScanConfigurationSchedulerController extends BaseWebComponentController {
  public component: EasmScanConfigurationSchedulerWebComponent;
  public view: EasmScanConfigurationSchedulerView;
  public viewConstructor: typeof EasmScanConfigurationSchedulerView;
  public companyId: string;
  public isSaveButtonDisabled: Boolean = true;

  constructor(component: EasmScanConfigurationSchedulerWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: EasmScanConfigurationSchedulerView,
      viewTemplate: templateEasmScanConfigurationScheduler,
    });
  }

  public setCompanyId(companyId: string): void {
    this.companyId = companyId;
  }

  public computeEventListeners(): IListenerConfig[] {
    return [
      {
        element: this.view.dom.$weeklyOnFormField,
        event: MultiSelectEvents.CHANGE,
        callback: this.handleDayPickerChange,
      },
    ];
  }

  private handleDayPickerChange(): void {
    const selectedDays = this.view.dom.$weeklyOnFormField.Input.getFormValue() as WeekDays[];
    if (selectedDays.length === 0) {
      this.isSaveButtonDisabled = true;
      this.view.dom.$weeklyOnFormField.dispatchEvent(
        new CustomEvent(EASMSchedulerEvents.DAY_PICKER_EMPTY, {
          detail: {},
          bubbles: true,
          composed: true,
        })
      );
    }
    if (selectedDays.length > 1) {
      this.view.setWeekDaysValue(this.view.dom.$weeklyOnFormField.Input.getFormValue()[1] as WeekDays);
    }
    if (selectedDays.length > 0 && this.isSaveButtonDisabled) {
      this.isSaveButtonDisabled = false;
      this.view.dom.$weeklyOnFormField.dispatchEvent(
        new CustomEvent(EASMSchedulerEvents.DAY_PICKED, {
          detail: {},
          bubbles: true,
          composed: true,
        })
      );
    }
  }

  public getDataForUpdate() {
    return {
      companyId: this.companyId,
      configuration: {
        dayOfWeek: this.view.dom.$weeklyOnFormField.Input.getFormValue()[0] as WeekDays,
        hour: this.view.dom.$betweenStartFormField.Input.getFormValue().hours,
        minute: this.view.dom.$betweenStartFormField.Input.getFormValue().minutes,
      },
    };
  }

  public async getDataForView(): Promise<{
    viewData: EasmScanConfigurationSchedulerSchema | null;
  }> {
    const viewData = await ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.CORE,
      endpoint: 'EASMScanConfigurations',
      method: 'getLastScanConfigurationByCompanyId',
      payload: {
        companyId: this.companyId,
      },
    });

    return {
      viewData: {
        lastScanDate: viewData.lastScan,
        nextScheduledScan: viewData.nextScan,
        isActive: viewData.isActive,
        weeklyRecurrence: { day: viewData.configuration?.dayOfWeek },
        start: {
          hours: viewData.configuration?.hour,
          minutes: viewData.configuration?.minute,
        },
      },
    };
  }
}
